import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { addEnroll } from "../../services/DroneServices";
import { toast } from "react-toastify";
import {  verifyEnrollOtp } from "../../services/OtpServices";

const CourseInquire = ({ setModel, model }) => {
    const [number ,setNumber]=useState("")
    const [step, setStep] = useState(1)
    const handleInquireModel = () => {
        setStep(1)
        setModel(false);
    };

    const { id } = useParams();

    const [formData, setFormData] = useState({
        name: "",
        phoneNumber: "",
        email: "",
        comment: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmitInquire = () => {
        if (formData?.phoneNumber?.length != 10) {
            return toast.error("Please enter a valid number")
        }
        setNumber(formData.phoneNumber)
        const data = {
            courseId: id,
            name: formData.name,
            email: formData.email,
            number: formData.phoneNumber,
            comment: formData.comment,
        }
        addEnroll(data).then((res) => {
            if (res.status == "success") {
                setFormData({
                    name: "",
                    phoneNumber: "",
                    email: "",
                    comment: ""
                })
                setStep(2)

            }
        })
    }
    const [otp, setOtp] = useState(["", "", "", ""]); // Array to hold OTP values
    const inputRefs = useRef([]); // Ref to hold references of input fields

    // Function to handle input change
    const handleChange = (index, event) => {
        const newOtp = [...otp];
        newOtp[index] = event.target.value;

        // Restrict input to one character
        if (event.target.value.length > 1) {
            newOtp[index] = event.target.value.slice(0, 1);
        }

        // Move to the next input field if there is a value and not the last input
        if (event.target.value !== "" && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }

        setOtp(newOtp);
    };

    // Function to handle backspace press
    const handleBackspace = (index, event) => {
        if (event.keyCode === 8 && index > 0 && otp[index] === "") {
            inputRefs.current[index - 1].focus();
        }
    };
    const verifyOtpHandle = () => {
        const combinedOtp = otp.join("");
        if (combinedOtp.length != 4) {
            toast.error("Enter Valid OTP")
            return
        }
        const data = {
            number: number,
            otp: combinedOtp
        }
        verifyEnrollOtp(data).then((res) => {
            if (res.status == "success") {
                toast.success("We will contact you soon")
                setTimeout(() => {
                    setFormData({
                        name:"",
                        phoneNumber:"",
                        email:"",
                        comment:""
                    })
                    setOtp(["","","",""])
                    setModel(0)
                }, 600);
            } else {
                toast.error(res.message)
            }
        })
    }
   
    
    return (
        <div>
            <Modal show={model} onHide={handleInquireModel}>
                <Modal.Header className="border-0 pb-0" closeButton></Modal.Header>
                {step == 1 ? <Modal.Body className="px-4 pb-4 d-flex flex-column justify-content-between">
                    <div>
                        <h4 className="fw-bold fs_22 color_darkgray">
                            Send your enquiry
                        </h4>
                        <div className="">
                            <div className="row">
                                <div>
                                    <label className="mb-2 fs_11 fw-semibold" htmlFor="">Name</label>
                                    <input
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="mt-2">
                                    <label className="mb-2 fs_11 fw-semibold" htmlFor="">Contact Number</label>
                                    <input
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="mt-2">
                                    <label className="mb-2 fs_11 fw-semibold" htmlFor="">Email</label>
                                    <input
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        type="text"
                                        className="form-control"
                                    />
                                </div>
                                <div className="my-2">
                                    <label className="mb-2 fs_11 fw-semibold" htmlFor="">Comment</label>
                                    <textarea
                                        name="comment"
                                        value={formData.comment}
                                        onChange={handleInputChange}
                                        className="form-control"
                                        cols="30"
                                        rows="5"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-center">
                        <button onClick={handleSubmitInquire}
                            className="tab_btn w-100 border-0 py-2 rounded-2 fs_21 fw-semibold ff_inter text-white"
                            type="submit"
                        >
                            Continue <FaArrowRight />
                        </button>
                    </div>
                </Modal.Body> : <Modal.Body className="px-4 pb-4 d-flex flex-column justify-content-between">
                    <div>
                        <h4 className="fw-bold ff_inter custom_size color_darkgray">
                            Verify OTP
                        </h4>
                        <p className="fs_17 ff_inter fw-normal color_darkgray mt-2">
                            Enter Verification Code
                        </p>
                        <div className="text-center">
                            <div className="d-flex justify-content-between mt-4">
                                {otp.map((value, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (inputRefs.current[index] = el)} // Store input reference
                                        className="custom_otp_input rounded-1 fs_41 ff_inter fw-bold px-2"
                                        type="number"
                                        maxLength={1} // Allow only single character input
                                        value={value}
                                        onChange={(event) => handleChange(index, event)}
                                        onKeyDown={(event) => handleBackspace(index, event)}
                                    />
                                ))}
                            </div>
                        </div>

                    </div>
                    <div className="text-center">
                        {/* <p className="fs_12 ff_inter fw-normal color_gray mb-2">
                            Didn't Receive OTP{" "}
                            <span className="fw-bold color_blue cursor_pointer">
                                Resend?
                            </span>
                        </p> */}
                        <button onClick={verifyOtpHandle}
                            className="tab_btn w-100 border-0 py-2 rounded-2 fs_21 fw-semibold ff_inter text-white"
                            type="submit"

                        >
                             Continue 
                            <FaArrowRight />
                        </button>
                    </div>
                </Modal.Body>}

            </Modal>
        </div>
    );
};

export default CourseInquire;
